import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/tournaments/divisions/$divisionId")({
  component: RouteComponent,
  loader: async ({
    params: { divisionId },
    context: { queryClient, trpc },
  }) => {
    const id = Number.parseInt(divisionId, 10);
    if (Number.isNaN(id)) throw notFound();

    const result = await queryClient.ensureQueryData(
      trpc.tournaments.getDivisionTournament.queryOptions({
        tournamentDivisionId: id,
      }),
    );

    if (!result) throw notFound();

    throw redirect({
      to: "/tournaments/$tournamentId/$divisionId/{-$tab}",
      params: {
        tournamentId: result.tournamentId.toString(),
        divisionId,
      },
    });
  },
});

function RouteComponent() {
  return null;
}
